import Delinquent from './Delinquent';

export default Delinquent;
